import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "../../gdpr/ui/DropdownFunctions";
import SpinnerDiv from "../../gdpr/ui/SpinnerDiv";
import PropTypes from "prop-types";
import {getGroupPupils} from "../../gdpr/ui/DropdownDataProviders";

const DropdownGroupPupils = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        if(props.group_id !== 0)
        {
            getGroupPupils(props.group_id).then(rows =>
            {
                //Add the All option to the top of dropdown
                const all = {label: 'All', value: 0}
                rows.unshift(all);
                setData({loading: false, items: rows});
            })
        }
        else{
            let data = [];
            const all = {label: 'All', value: 0}
            data.unshift(all);
            setData ( { loading: false, items: data }) ;
        }
    }, [props.group_id]);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownGroupPupils;

DropdownGroupPupils.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownGroupPupils.propTypes = {
    onChange: PropTypes.func.isRequired
};